import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=653b4a7e&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=653b4a7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653b4a7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('653b4a7e')) {
      api.createRecord('653b4a7e', component.options)
    } else {
      api.reload('653b4a7e', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=653b4a7e&scoped=true&", function () {
      api.rerender('653b4a7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2qc23xah3NoK0/JS/comp/PopupDialog.vue"
export default component.exports